import {
  DeleteOutlined,
  DiffOutlined,
  EditOutlined,
  FieldTimeOutlined,
  PlusOutlined
} from '@ant-design/icons'
import dayjs from 'dayjs'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import {
  convertPriceToNumber,
  formatCurrency,
  formatCurrencyLabel,
  formatCurrencyUnit,
  getLabelByValue,
  hasPermission,
  removeNullUndefined,
  removeUndefinedValues
} from '../../config-func'
import { PAGE_SIZE_OPTIONS, TagCustom } from '../../configData'
import {
  getListStaff,
  postSearchWeb,
  addressSearch,
  addressSearchAll,
  projectSearch,
  requestDetail,
  getProjectLibraryListForWeb,
  requestDetailInfoPost,
  updateDetailPostWeb,
  postDelete
} from '../../services/postservice'
import Card from '../Card'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import TableField from '../common/Table/TableField'
import PhoneVisibilityCell from '../common/PhoneVisibilityCell'
import ExportButton from '../common/ExportButton'
import {
  APARTMENT_TYPE,
  BALCONY_DIRECTION,
  FURNITURE_TYPE,
  ProductType,
  status,
  statusList
} from '../PostManagement/configs'
import FilterForm from './FilterForm'
import openNotification from '../common/Notification/openNotification '
import { Button, Form, Space, Tooltip } from 'antd'
import ModalCustom from '../common/Modal/ModalCustom'
import FormPost from './FormPost'
import { columnLabel, NHU_CAU } from './configs'
import {
  buildSubProductTypeFromCategory,
  formatDate,
  getSubProductType,
  mapSelectionByCategory
} from '../../utils/helpers'
import { departmentSearch } from '../../services/cmsservice'
import CallModal from './CallModal'
import { getAllSelectionsList } from '../../services/selection-list-service'
import { getAllAddressData } from '../../utils/address'
import { useAddressFilter } from '../../hooks/useAddressFilter'
import {
  getLabelText,
  mapLabelToDemand,
  mapMediaForSubmit,
  mapMediaFromApi
} from './helpers'
import { getPackageListFeeWeb } from '../../services/pakage-post'
import MediaUpload from './MediaUpload'
import get from 'lodash.get'
import Note from './Note'
import Description from './Description'
import Loading from '../Loading'

const priorityToCardMap = {
  HIGH: 'cronw-limited',
  MEDIUM: 'cronw-luxury',
  LOW: 'cronw-premium'
}

const ManagerPostWeb = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [form] = Form.useForm()
  const [formSearch] = Form.useForm()
  const skipAutoTitleOnInitRef = useRef(true)
  const isTitleManuallyEditedRef = useRef(false)
  const [typeRealEstate, setTypeRealEstate] = useState([])

  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [listUser, setListUser] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [listDepartment, setListDepartment] = useState([])
  const [typeRealEstateOps, setTypeRealEstateOps] = useState([])
  const [listRequest, setListRequest] = useState([])
  const [listAllSelections, setListAllSelections] = useState([])
  const [cities, setCities] = useState([])
  const [districts, setDistricts] = useState([])
  const [towns, setTowns] = useState([])
  const [postType, setPostType] = useState('')
  const [demandOps, setDemandOps] = useState([])
  const [typeOfRealEstateOps, setTypeOfRealEstateOps] = useState([])
  const [apartmentLocationOptions, setApartmentLocationOptions] = useState([])
  const [directionOptions, setDirectionOptions] = useState([])
  const [furnitureOptions, setFurnitureOptions] = useState([])
  const [legalOptions, setLegalOptions] = useState([])
  const [procedureOptions, setProcedureOptions] = useState([])
  const [currentStatusOpstions, setCurrentStatusOpstions] = useState([])
  const [postStatusOptions, setPostStatusOptions] = useState([])
  const [postSecurityOptions, setPostSecurityOptions] = useState([])
  const [recordId, setRecordId] = useState()

  const [isOpenCall, setIsOpenCall] = useState(false)
  const [projectLibrary, setProjectLibrary] = useState([])
  const [packageListFeeWeb, setPackageListFeeWeb] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [detailPost, setDetailPost] = useState(null)
  const [isModalNote, setIsModalNote] = useState(false)
  const [isModalDescription, setIsModalDescription] = useState(false)

  const [media, setMedia] = useState({
    images: [],
    videos: [],
    image_360: []
  })

  const cityCode = Form.useWatch('cityCode', form)
  const districtCode = Form.useWatch('districtCode', form)
  const labelWatch = Form.useWatch('label', form)

  const postTypeWatch = Form.useWatch('postType', form)
  const typeRealEstateWatch = Form.useWatch('typeRealEstate', form)
  const projectIdWatch = Form.useWatch('projectId', form)
  const packageId = form.getFieldValue('packageId')

  const {
    filteredDistricts,
    filteredTowns,
    filterDistrictsByCity,
    filterTownsByDistrict,
    resetAddressFilter
  } = useAddressFilter({
    districts,
    towns,
    cityCode,
    districtCode
  })

  const [pagination, setPagination] = useState({
    current: 1, // Trang hiện tại
    pageSize: 10 // Số bản ghi mỗi trang
  })

  const getDetailRequest = async (id) => {
    setLoading(true)
    try {
      const res = await requestDetailInfoPost(id) // Assuming roleSearch is an API function

      if (res && res.data) {
        setIsModalOpen(true)
        const values = {
          ...res.data,
          type_user:
            res.data.typeUser !== undefined && res.data.typeUser !== null
              ? String(res.data.typeUser)
              : res.data.type_user !== undefined && res.data.type_user !== null
              ? String(res.data.type_user)
              : undefined,
          direction: String(res.data.direction),
          label:
            res.data.label?.toString() ||
            res.data.requestType?.toString() ||
            null,
          postType: String(res.data.postType) || null,
          typeRealEstate: String(res.data.typeRealEstate) || null,
          projectId: String(res.data.projectId),
          cityCode: res.data.cityCode?.toString() || null,
          districtCode: res.data.districtCode?.toString() || null,
          townCode: res.data.townCode?.toString() || null,
          street: res.data.street || '',
          packageId: res.data.packageId || res.data.packagesCustomerId || null,
          procedure: String(res.data.procedure),
          legal: String(res.data.legal),
          apartmentLocation: String(res.data.apartmentLocation),
          furniture: String(res.data.furniture)
        }
        setDetailPost(res.data)
        form.setFieldsValue({
          ...values,
          price: values.price ? formatCurrency(values.price) : ''
        })
        const type = getSubProductType(
          String(values.postType),
          SUB_PRODUCT_TYPE_DYNAMIC
        )

        setTypeRealEstateOps(type)
        setPostType(String(values.postType))
        setMedia(mapMediaFromApi(res.data.postFiles))
        setLoading(false)
      }
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
    }
  }
  const deleteRequest = async (ids) => {
    setLoading(true)
    try {
      // Validate các trường trong form
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const deId = localStorage.getItem('department_id')
      // Lọc ra các key có giá trị true và đưa vào mảng
      const body = {
        ids,
        department_id: deId
      }
      const res = await postDelete(body)
      getListRequest()
      setSelectedRowKeys([])
      openNotification('success', res.message)
      setLoading(false)
    } catch (err) {
      setLoading(false)

      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }

  const handleProjectNameChange = (value) => {
    form.setFieldsValue({ projectId: value })

    if (!value) {
      form.setFieldsValue({
        cityCode: null,
        districtCode: null,
        townCode: null,
        street: '',
        projectName: ''
      })

      filterDistrictsByCity('')
      filterTownsByDistrict('')
      return
    }

    const selectedProject = projectLibrary.find(
      (p) => p.value === value || p.id === value
    )

    if (!selectedProject) return

    const cityCode = selectedProject.cityCode?.toString()
    const districtCode = selectedProject.districtCode?.toString()
    const townCode = selectedProject.townCode?.toString()

    form.setFieldsValue({
      projectName: selectedProject.label,
      street: selectedProject.address || ''
    })

    if (cityCode) {
      form.setFieldsValue({ cityCode: cityCode })
      filterDistrictsByCity(cityCode)

      if (districtCode) {
        setTimeout(() => {
          form.setFieldsValue({ districtCode: districtCode })
          filterTownsByDistrict(districtCode)

          if (townCode) {
            setTimeout(() => {
              form.setFieldsValue({ townCode: townCode })
            }, 0)
          }
        }, 0)
      }
    }
  }

  const SUB_PRODUCT_TYPE_DYNAMIC = useMemo(
    () =>
      buildSubProductTypeFromCategory(listAllSelections, [
        'APARTMENT_BDS',
        'BUILDING_BDS',
        'GROUND_BDS',
        'REAL_ESTATE_BDS'
      ]),
    [listAllSelections]
  )
  const onChangePostType = (e) => {
    const type = getSubProductType(e, SUB_PRODUCT_TYPE_DYNAMIC)

    // const formattedArray = type?.map((item) => ({ value: item, label: item }))
    form.setFieldsValue({
      typeRealEstate: null
    })
    setTypeRealEstate(type)
    setTypeRealEstateOps(type)
    setPostType(String(e))
  }

  const getListRequest = async (values = {}) => {
    setLoading(true)
    const { acreage, area_outside, ...value } = values

    let _dataSource = []
    let _total = 0
    const params = removeUndefinedValues({
      ...value,
      page: pagination.current,
      pageSize: pagination.pageSize,
      from: 1
    })

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await postSearchWeb(cleanedData)
      _dataSource = response?.data?.list
      _total = response?.data?.total
    } catch (error) {
      openNotification(
        'error',
        error?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    } finally {
      setLoading(false)
      setDataSource(_dataSource)
      setTotal(_total)
    }
  }
  const getDepartmentAll = async (values) => {
    let { name = '', type = '', page = 1, pageSize = 1000 } = values || {}
    try {
      const body = { name, type, page, pageSize }
      const res = await departmentSearch(body)
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.id,
        label: item.name
      }))
      setListDepartment(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra2'
      )
    }
  }

  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()

      const { id, ...data } = values
      let body = {}
      body = {
        ...detailPost,
        ...data,
        id: String(id),
        price: values.price
          ? convertPriceToNumber(values.price?.toString())
          : 0,
        postFiles: mapMediaForSubmit(media),
        typeRealEstate: Number(values.typeRealEstate),
        apartmentLocation: Number(values.apartmentLocation),
        direction: Number(values.direction),
        legal: Number(values.legal),
        furniture: Number(values.furniture),
        procedure: Number(values.procedure)
      }
      if (values.type_user !== undefined && values.type_user !== null) {
        body.typeUser = Number(values.type_user)
        delete body.type_user
      }
      if (!values.price || values.price === 0) {
        delete body.price
      }
      const res = await updateDetailPostWeb(body)

      if (res && res.data?.id) {
        openNotification('success', 'Cập nhật tin thành công')
        // const value = formSearch.getFieldsValue()

        form.resetFields()
        setIsModalOpen(false)
        fetchData()
      } else {
        openNotification('error', 'Đã có lỗi xảy ra')
      }
    } catch (err) {
      // Lấy danh sách lỗi từ API
      const errors = get(err, 'response.data.message', [])

      // Xử lý lỗi nếu là mảng
      const errorMessages = Array.isArray(errors)
        ? errors.map((error) => error.message).join('\n')
        : errors // Nếu không phải mảng, lấy trực tiếp

      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Danh sách tài khoản theo SÀN

  useMemo(() => {
    if (pagination.current && pagination.pageSize) {
      const value = formSearch.getFieldsValue()
      getListRequest({
        ...value,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
    }
  }, [pagination.current, pagination.pageSize])

  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1
    },
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60
    },
    {
      title: 'Nhu cầu',
      dataIndex: 'label',
      key: 'label',
      width: 100,
      render: (value) => {
        const nhuCau = demandOps.find((item) => item.value === String(value))
        return nhuCau ? nhuCau.label : '-' // Nếu không tìm thấy, hiển thị "-"
      }
    },
    {
      title: 'Loại BĐS',
      dataIndex: 'post_type',
      key: 'post_type',
      width: 150,
      render: (_, record) => (
        <span>
          {typeOfRealEstateOps.find(
            (n) => Number(n.value) === Number(record.post_type)
          )?.label || ''}
        </span>
      )
    },
    {
      title: 'Loại hình BĐS',
      dataIndex: 'type_real_estate',
      key: 'type_real_estate',
      width: 150,
      render: (_, record) => (
        <span>
          {getLabelByValue(record.type_real_estate, listAllSelections)}
        </span>
      )
    },
    {
      title: 'Tên khách hàng',
      dataIndex: 'customer_name',
      key: 'customer_name',
      width: 150
    },
    {
      title: 'SĐT khách hàng',
      dataIndex: 'customer_phone_number',
      key: 'customer_phone_number',
      width: 170,
      render: (_, record) => (
        <PhoneVisibilityCell
          value={record?.customer_phone_number}
          postId={record?.id}
        />
      )
    },
    {
      title: 'Xác thực định danh',
      dataIndex: 'type_user',
      key: 'type_user',
      width: 170,
      render: (_, record) => (
        <span>
          {record.type_user == '0'
            ? 'Khách hàng'
            : record.type_user == '1'
            ? 'Môi giới bất động sản'
            : ''}
        </span>
      )
    },
    {
      title: 'Người đăng',
      dataIndex: 'user_info',
      key: 'user_info',
      width: 150,
      render: (_, record) => <span>{record?.user_info?.name}</span>
    },
    {
      title: 'SĐT người đăng',
      dataIndex: 'user_info',
      key: 'user_info',
      width: 170,
      render: (_, record) => (
        <PhoneVisibilityCell
          value={record?.user_info?.phone}
          postId={record?.id}
        />
      )
    },
    {
      title: 'Gói tin',
      dataIndex: 'priority',
      key: 'priority',
      width: 120,
      render: (_, record) => (
        <span>
          {record.priority == 1
            ? 'Limited'
            : record.priority == 2
            ? 'Luxury'
            : record.priority == 3
            ? 'Premium'
            : record.priority == 4
            ? 'Deluxe'
            : record.priority == 5
            ? 'Basic'
            : ''}
        </span>
      )
    },
    {
      title: 'Hiện trạng',
      dataIndex: 'priority',
      key: 'priority',
      width: 120,
      render: (_, record) => (
        <span>
          {record.priority && record.priority == 999
            ? 'Hết hạn'
            : 'Đang hiển thị'}
        </span>
      )
    },
    {
      title: 'Mã căn hộ',
      dataIndex: 'apartment_code',
      key: 'apartment_code',
      width: 120
    },
    {
      title: 'Số địa chỉ',
      dataIndex: 'alley',
      key: 'alley',
      width: 120
    },
    {
      title: 'Vị trí',
      dataIndex: 'apartment_location',
      key: 'apartment_location',
      width: 150,
      render: (_, record) => (
        <span>
          {apartmentLocationOptions.find(
            (n) => n.value === String(record.apartment_location)
          )?.label || ''}
        </span>
      )
    },
    {
      title: 'Hướng',
      dataIndex: 'direction',
      key: 'direction',
      width: 150,
      render: (_, record) => (
        <span>
          {directionOptions.find((n) => n.value === String(record.direction))
            ?.label || ''}
        </span>
      )
    },
    {
      title: 'Diện tích (m2)',
      dataIndex: 'acreage',
      key: 'acreage',
      width: 150
    },
    {
      title: 'Mặt tiền (m)',
      dataIndex: 'area_outside',
      key: 'area_outside',
      width: 150
    },
    {
      title: 'Tầng',
      dataIndex: 'number_of_floor',
      key: 'number_of_floor',
      width: 150
    },
    {
      title: 'Số phòng ngủ',
      dataIndex: 'number_of_bedrooms',
      key: 'number_of_bedrooms',
      width: 150
    },
    {
      title: 'Số WC',
      dataIndex: 'number_of_wc',
      key: 'number_of_wc',
      width: 150
    },
    {
      title: 'Nội thất',
      dataIndex: 'furniture',
      key: 'furniture',
      width: 150,
      render: (_, record) => (
        <span>
          {furnitureOptions.find((n) => n.value === String(record.furniture))
            ?.label || ''}
        </span>
      )
    },
    {
      title: 'Giá',
      dataIndex: 'price',
      key: 'price',
      width: 150,
      render: (_, record) => <span>{formatCurrencyLabel(record.price)}</span>
    },
    {
      title: 'Tỉnh/Thành phố',
      dataIndex: 'cityCode',
      key: 'cityCode',
      width: 150,
      render: (_, record) => <span>{record?.city_info?.name}</span>
    },
    {
      title: 'Quận/Huyện',
      dataIndex: 'districtCode',
      key: 'districtCode',
      width: 120,
      render: (_, record) => <span>{record?.district_info?.name}</span>
    },
    {
      title: 'Phường/Xã',
      dataIndex: 'townCode',
      key: 'townCode',
      width: 150,
      render: (_, record) => <span>{record?.town_info?.name}</span>
    },
    {
      title: 'Thời gian đăng',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (_, record) => <span>{formatDate(record?.created_at)}</span>
    },
    {
      title: 'Thời gian gia hạn',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 150,
      render: (_, record) => <span>{formatDate(record?.updated_at)}</span>
    },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            {hasPermission('P38.3', permissions) && (
              <Tooltip title="Chỉnh sửa">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    getDetailRequest(record.id)
                  }}
                />
              </Tooltip>
            )}

            {hasPermission('P38.7', permissions) && (
              <Tooltip title="Xem mô tả">
                <Button
                  onClick={() => {
                    setRecordId(record.id)

                    setIsModalDescription(true)
                  }}
                >
                  <FieldTimeOutlined />
                  Mô tả
                </Button>
              </Tooltip>
            )}
            {/* </Tooltip> */}

            {hasPermission('P38.4', permissions) && (
              <Tooltip title="Xóa">
                <Button
                  style={{ width: 32 }}
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                  onClick={() =>
                    showConfirm({
                      title: 'Xác nhận xoá',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xoá yêu cầu
                          <b>
                            {' '}
                            {record.request_type == 'RENTING'
                              ? 'thuê'
                              : 'bán'}{' '}
                          </b>
                          của <b>{record.customer_full_name}</b> không?
                        </div>
                      ),
                      onOk: () => deleteRequest([record.id])
                    })
                  }
                />
              </Tooltip>
            )}
          </Space>
        )
      }
    }
  ]

  const getSelection = async () => {
    try {
      const res = await getAllSelectionsList()
      setListAllSelections(res || [])
    } catch (err) {}
  }

  // Danh sách quận huyện
  const getAllAddress = async (code) => {
    const params = {
      parent_code: code
    }
    try {
      const res = await getAllAddressData()
      setDistricts(
        res.districts.map((item) => ({
          ...item,
          value: item.code,
          label: item.name
        })) || []
      )
      setCities(
        res.cities.map((item) => ({
          ...item,
          value: item.code,
          label: item.name
        })) || []
      )
      setTowns(
        res.towns.map((item) => ({
          ...item,
          value: item.code,
          label: item.name
        })) || []
      )
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  const onChangeProject = async (value) => {
    const dataProject = _.find(listRequest, (el) => el.id === value)

    await getListDistricts(dataProject.cityCode)
    await getListTowns(dataProject.districtCode)

    form.setFieldsValue({
      cityCode: dataProject.cityCode,
      districtCode: dataProject.districtCode,
      townCode: dataProject.townCode,
      street: dataProject.address,
      project_name: dataProject.project_name
    })
  }

  const fetchProjectLibraryListForWeb = async () => {
    const response = await getProjectLibraryListForWeb()
    if (response.code === 200) {
      const dataFormat = response.data.map((item) => ({
        value: item.id?.toString() || String(item.id), // Ensure value is string to match projectId
        label: item.projectName,
        ...item
      }))
      setProjectLibrary(dataFormat)
    } else {
      setProjectLibrary([])
    }
  }
  // Chọn city hay district thì call api
  const onChangeCity = (e) => {
    getListDistricts(e)
    form.setFieldsValue({
      districtCode: null,
      townCode: null
    })
  }
  const onChangeDepartment = async (value) => {
    // await getUserAll(value)
    // form.setFieldsValue({
    //   manager_post_id: null
    // })
  }
  const onChangeDistrict = (e) => {
    const code = districts.filter((item) => item.code == e)?.[0]?.code

    getListTowns(code)
    form.setFieldsValue({
      town_code: null
    })
  }

  // Danh sách quận huyện
  const getListDistricts = async (code) => {
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'district')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setDistricts(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  // Danh sách phường xã
  const getListTowns = async (code) => {
    const params = {
      parent_code: code
    }
    try {
      const res = await addressSearch(params, 'town')
      const result = res?.data?.list.map((item) => ({
        ...item,
        value: item.code,
        label: item.name
      }))
      setTowns(result)
    } catch (err) {
      openNotification(
        'error',
        err?.response?.data?.message || 'Đã có lỗi xảy ra'
      )
    }
  }

  const getPropertyFormName = (value) => {
    const subTypes = getSubProductType(postTypeWatch, SUB_PRODUCT_TYPE_DYNAMIC)
    const propertyForm = subTypes.find((type) => type.value === value)
    return propertyForm ? propertyForm.name : ''
  }
  const projectNameWatch = useMemo(() => {
    if (!projectIdWatch) return ''
    const project = projectLibrary?.find(
      (e) => String(e.id) === String(projectIdWatch)
    )
    return project?.projectName || ''
  }, [projectIdWatch, projectLibrary])
  useEffect(() => {
    isTitleManuallyEditedRef.current = false
  }, [labelWatch, postTypeWatch, typeRealEstateWatch, projectNameWatch])
  useEffect(() => {
    // ⛔ skip đúng 1 lần khi vừa set detail / init
    if (skipAutoTitleOnInitRef.current) {
      skipAutoTitleOnInitRef.current = false
      return
    }

    // ✋ user đã sửa tay → không auto nữa
    if (isTitleManuallyEditedRef.current) return

    if (!labelWatch || !postTypeWatch || !typeRealEstateWatch) return

    const labelText = getLabelText(String(labelWatch))
    const propertyFormName = getPropertyFormName(String(typeRealEstateWatch))

    const newTitle = `${labelText} ${propertyFormName}${
      projectNameWatch ? ' ' + projectNameWatch : ''
    }`

    const currentTitle = form.getFieldValue('title')

    if (newTitle !== currentTitle) {
      form.setFieldsValue({ title: newTitle })
    }
  }, [labelWatch, postTypeWatch, typeRealEstateWatch, projectNameWatch])
  const fetchPackageListFeeWeb = async () => {
    const label = String(form.getFieldValue('label') || '')
    const postType = String(form.getFieldValue('postType') || '')
    const typeRealEstate = String(form.getFieldValue('typeRealEstate') || '')
    const demand = mapLabelToDemand(label)

    if (!postType || !typeRealEstate) {
      setPackageListFeeWeb([])
      return
    }

    const response = await getPackageListFeeWeb(
      postType,
      demand,
      typeRealEstate
    )

    if (response.code !== 200) {
      setPackageListFeeWeb([])
      return
    }
    setPackageListFeeWeb(
      response.data.map((item) => ({
        ...item,
        value: item.id,
        label: `${item.packageProperties.name} - Ưu tiên ${item.packageProperties.priority}`
      }))
    )

    // ===== GROUP PACKAGE =====
  }

  useEffect(() => {
    if (labelWatch && postTypeWatch && typeRealEstateWatch) {
      fetchPackageListFeeWeb()
    }
  }, [labelWatch, postTypeWatch, typeRealEstateWatch])

  useEffect(() => {
    getDepartmentAll()
    getSelection()
    getAllAddress()
    fetchProjectLibraryListForWeb()
  }, [])
  useEffect(() => {
    setTimeout(() => {
      mapSelectionByCategory(listAllSelections, [
        {
          // nhu cầu
          category: 'DEMAND',
          setState: setDemandOps
        },
        {
          // loại bất động sản
          category: 'TYPE_OF_REAL_STATE',
          setState: setTypeOfRealEstateOps
        },
        {
          // vị trí căn hộ
          category: 'LOCATION',
          setState: setApartmentLocationOptions
        },
        {
          // hướng căn hộ
          category: 'DIRECTION',
          setState: setDirectionOptions
        },
        {
          // phí giao dịch
          category: 'PROCEDURE',
          setState: setProcedureOptions
        },
        {
          // giấy tờ pháp lý
          category: 'LEGAL',
          setState: setLegalOptions
        },
        {
          // nội thất
          category: 'FURNITURE',
          setState: setFurnitureOptions
        },
        {
          // hiện trạng
          category: 'CURRENT_STATUS',
          setState: setCurrentStatusOpstions
        },
        {
          // trạng thái tin
          category: 'POST_STATUS',
          setState: setPostStatusOptions
        },
        {
          // trạng thái tin
          category: 'POST_SECURITY',
          setState: setPostSecurityOptions
        }
      ])
    }, 0)
  }, [listAllSelections])
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          form={formSearch}
          getListRequest={getListRequest}
          listDepartment={listDepartment}
          listRequest={listRequest}
          cities={cities}
          districts={districts}
          towns={towns}
          user={listUser}
          LabelType={columnLabel?.slice(0, 2) || []}
          onChangePostType={onChangePostType}
          listTypeRealEstate={typeRealEstate}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          onChangeDepartment={onChangeDepartment}
          pagination={pagination}
          setPagination={setPagination}
          // setPagination removed in favor of setFilters
          demandOps={demandOps}
          typeOfRealEstateOps={typeOfRealEstateOps}
          apartmentLocationOptions={apartmentLocationOptions}
          directionOptions={directionOptions}
          furnitureOptions={furnitureOptions}
          currentStatusOpstions={currentStatusOpstions}
          postStatusOptions={postStatusOptions}
          postSecurityOptions={postSecurityOptions}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            <ExportButton
              columns={initialColumns}
              data={dataSource}
              fileName="Quan_ly_tin_dang_tren_Web"
              sheetName="Tin đăng trên Web"
              permission="P57.3"
            />
            <Button
              danger
              disabled={selectedRowKeys.length > 0 ? false : true}
              type="primary"
              onClick={() => {
                showConfirm({
                  title: 'Xác nhận xoá',
                  content: (
                    <div>
                      Bạn có chắc chắn muốn xoá <b>{selectedRowKeys?.length}</b>{' '}
                      yêu cầu không?
                    </div>
                  ),
                  onOk: () => deleteRequest(selectedRowKeys)
                })
              }}
            >
              <DeleteOutlined />
              Xoá
            </Button>
            {/* )} */}
          </div>
        </div>

        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{
            x: dataSource?.length > 0 ? 'max-content' : '100%',
            y: 'calc(100vh - 400px)'
          }}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setPagination((prev) => ({
                ...prev,
                pageSize: size,
                current: 1
              }))
            },
            onChange: (page) => {
              setPagination((prev) => ({ ...prev, current: page }))
            },
            showTotal: (total, range) =>
              `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          className={`custom-table`}
          rowKey="id"
          locale={{ emptyText: 'Không có dữ liệu' }}
          rowSelection={{
            selectedRowKeys: selectedRowKeys, // Mảng chứa các row được chọn
            onChange: (selectedKeys) => {
              setSelectedRowKeys(selectedKeys)
            }, // Xử lý khi chọn row
            type: 'checkbox', // Hoặc 'radio' nếu chỉ chọn được 1
            preserveSelectedRowKeys: true // Giữ selection khi phân trang
          }}
        />
      </Card>
      <ModalConfirm />
      <ModalCustom
        title={'Chỉnh sửa tin đăng trên Web'}
        visible={isModalOpen}
        centered
        width={1200}
        // className="modal-bond"
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            if (error?.errorFields?.length > 0) {
              form.scrollToField(error.errorFields[0].name, {
                behavior: 'smooth',
                block: 'center' // Đảm bảo label không bị che
              })
            }
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
      >
        <FormPost
          form={form}
          // handleSearch={handleSearch}
          listDepartment={listDepartment}
          listUser={listUser}
          LabelType={demandOps}
          ProductType={ProductType}
          typeRealEstateOps={typeRealEstateOps}
          listRequest={listRequest}
          cities={cities}
          districts={filteredDistricts}
          towns={filteredTowns}
          postType={postType}
          onChangeProject={onChangeProject}
          onChangePostType={onChangePostType}
          onChangeCity={onChangeCity}
          onChangeDistrict={onChangeDistrict}
          onChangeDepartment={onChangeDepartment}
          demandOps={demandOps}
          typeOfRealEstateOps={typeOfRealEstateOps}
          apartmentLocationOptions={apartmentLocationOptions}
          directionOptions={directionOptions}
          furnitureOptions={furnitureOptions}
          legalOptions={legalOptions}
          procedureOptions={procedureOptions}
          currentStatusOpstions={currentStatusOpstions}
          postStatusOptions={postStatusOptions}
          postSecurityOptions={postSecurityOptions}
          projectLibrary={projectLibrary}
          handleProjectNameChange={handleProjectNameChange}
          labelWatch={labelWatch}
          packageListFeeWeb={packageListFeeWeb}
          packageId={packageId}
        />
        <MediaUpload value={media} onChange={setMedia} />
      </ModalCustom>
      <ModalCustom
        title="Danh sách quản lý note"
        visible={isModalNote}
        centered
        width={600}
        onCancel={() => {
          setIsModalNote(false)
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={''}
      >
        <Note id={recordId} />
      </ModalCustom>
      <ModalCustom
        title="Mô tả"
        visible={isModalDescription}
        centered
        width={600}
        onCancel={() => {
          setIsModalDescription(false)
        }}
        cancelText="Đóng"
        footer={''}
      >
        <Description id={recordId} loading={loading} setLoading={setLoading} />
      </ModalCustom>
      {/* <CallModal
        id={recordId}
        isOpen={isOpenCall}
        setIsOpen={setIsOpenCall}
        listDepartment={listDepartment}
        cities={citiesAll}
        districts={districtsAll}
        towns={townsAll}
      /> */}
    </div>
  )
}

export default ManagerPostWeb
